import { sessionState } from "@/state"

const ASSET_SCHEME_TOKEN = "asset://"

export const appendWebSessionId = function(url) {
    if (!url || !url.length) return url

    const sid = sessionState.session?.webSessionId
    if (!sid) return url

    if (url.indexOf("?") < 0) {
        url += "?"
    } else if (url[url.length - 1] !== "?") {
        url += "&"
    }

    url += "sid=" + encodeURIComponent(sid)

    return url
}

export const resolveAssetUrl = function(url) {
    if (!url) return ""
    if (!url.startsWith(ASSET_SCHEME_TOKEN)) return url
    url = url.substring(ASSET_SCHEME_TOKEN.length) || ""
    if (url[0] !== "/") url = "/" + url
    return require("@/assets" + url)
}
